// extracted by mini-css-extract-plugin
export default {"container":"OnevocaSearchInput_container__OMrOG","searchImage":"OnevocaSearchInput_searchImage__Qokj-","searchInput":"OnevocaSearchInput_searchInput__86cBE"};